import httpAuth from "@/common/http-common";
import { 
  ClientInfo,
  DropdownItem,
  ChangePassword,
  RegisterUserDto
} from "@/views/base/base.types";

class BaseService {
  async getClients(loginId: number) {
    const { data } = await httpAuth().get<ClientInfo[]>(
      '/Clients/GetClients', { params: { 
        loginId: loginId
      } 
    });
    return data;
  }

  async getAspNetRoles() {
    const { data } = await httpAuth().get<DropdownItem<string>[]>(
      '/Authentication/GetAspNetRoles'
    );
    return data;
  }

  async changePassword(changePassword: ChangePassword) {
    const { data } = await httpAuth().post(
      `Authentication/ChangePassword`,
      changePassword
    );
    return data;
  }

  async registerUser(registerUserDto: RegisterUserDto) {
    const { data } = await httpAuth().post(
      `Authentication/Register`,
      registerUserDto
    );
    return data;
  }
}

export default new BaseService();